import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Dropdown, DropdownMenu, DropdownToggle
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// users
import user1 from "src/assets/images/users/avatar-1.jpg";
import { useUserContext } from "src/globals/providers";
import '../Style/index.css';
import { CookiesKey, createAccessRoleCookie, getCookie } from "src/globals";


const ProfileMenu = (props: any) => {
  const { user, setUser } = useUserContext();
  const [menu, setMenu] = useState<boolean>(false);
  const isAdmin = user?.roles?.includes("Administrator") ?? false;
  const [accessRole, setAccessRole] = useState<string | undefined>();

  useEffect(() => {
    const role = getCookie(CookiesKey.ACCESS_ROLE);
    setAccessRole(role);
  }, []);

  return (
    <React.Fragment>

      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item bg-soft-light "
          style={{ position: "static" }}
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
            height="30"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1 text-light">{user?.username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu
          style={{ width: "150px" }}
          end
          data-bs-display="static"
        >
          {
            user?.role === "SuperAdministrator"
              ?
              <Link to="/admin-edit-profile" className="dropdown-item">
                <i className="bx bx-user font-size-16 align-middle me-1" />
                <span>Profile</span>
              </Link>
              :
              <Link to="/user-edit-profile" className="dropdown-item">
                <i className="bx bx-user font-size-16 align-middle me-1" />
                <span>Profile</span>
              </Link>
          }

        {isAdmin && accessRole === "User" && (
          <Link
            to="/admin-ticketing"
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-item"
            onClick={(e) => {
              e.preventDefault(); // stop Link navigation
        
              createAccessRoleCookie("Administrator");
        
              // open AFTER cookie is set
              window.open("/admin-ticketing", "_blank", "noopener,noreferrer");
            }}
          >
            <i className="bx bx-user font-size-16 align-middle me-1" />
            <span>Admin Access</span>
          </Link>
        )}

        {isAdmin && accessRole === "Administrator" && (
          <Link
            to="/admin-ticketing"
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-item"
            onClick={(e) => {
              e.preventDefault(); // stop Link navigation
        
              createAccessRoleCookie("User");
        
              // open AFTER cookie is set
              window.open("/ticketing", "_blank", "noopener,noreferrer");
            }}
          >
            <i className="bx bx-user font-size-16 align-middle me-1" />
            <span>Client Access</span>
          </Link>
        )}


          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>Logout</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};
export default withTranslation()(ProfileMenu);
